<ion-header [hidden]="scanCamera">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>
            Afboeking
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content [hidden]="scanCamera">
    <mat-card>
        <table class="taglist" width="100%">
            <tr>
                <td>
                    <ion-button size="small" (click)="doScanProj()" [hidden]="global.optHideScanBtn">
                        <ion-icon name="barcode"></ion-icon>
                    </ion-button>
                </td>
                <td><span class="tag">Ord.nr.</span></td>
                <td>
                    <input list='projlisting' placeholder="Project nummer" class="inputField" onclick="this.select()"
                        onselectstart="preventPopup()" (input)='projChanged($any($event.target).value)' [(ngModel)]='inpProjnr'>
                    <span *ngIf="projError"><br>{{projError}}</span>
                </td>
                <td width="100%"></td>
            </tr>
            <tr *ngIf="projlist.length">
                <td colspan="4">
                    <ion-list style="max-height: 300px; overflow-y: scroll; width: 100%;">
                        <ion-item *ngFor="let proj of projlist">
                            <ion-label (click)="click_proj(proj.nr)">{{ proj.des }}</ion-label>
                        </ion-item>
                    </ion-list>
                </td>
            </tr>
            <ng-container *ngIf="!projlist.length">
                <tr>
                    <td><ion-button size="small" [routerLink]="['/orders']"><ion-icon name="attach"></ion-icon></ion-button></td>
                    <td colspan="3">
                        {{projShow.descr}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <ion-button size="small" (click)="doScanArt()" [hidden]="global.optHideScanBtn">
                            <ion-icon name="barcode"></ion-icon>
                        </ion-button>
                    </td>
                    <td><span class="tag">Art.nr.</span></td>
                    <td>
                        <input list='artlisting' placeholder="Artikel nummer" class="inputField" onclick="this.select()"
                        onselectstart="preventPopup()" (input)='artChanged($any($event.target).value)' [(ngModel)]='inpArtnr'
                        #inpArtFld>
                    </td>
                </tr>
                <tr *ngIf="artlist.length">
                    <td colspan="4">
                        <ion-list style="max-height: 300px; overflow-y: scroll; width: 100%;">
                            <ion-item *ngFor="let art of artlist">
                                <ion-label (click)="click_art(art.nr)">{{ art.des }}</ion-label>
                            </ion-item>
                        </ion-list>
                    </td>
                </tr>
                <ng-container *ngIf="!artlist.length || artlist.length==1">
                    <tr>
                        <td rowspan="2"><ion-button size="small" [disabled]="!validArt" [routerLink]="['/home']"><ion-icon name="attach"></ion-icon></ion-button></td>
                        <td colspan="2">
                            {{artShow.descr}}
                        </td>
                        <td align="right" rowspan="3">
                            <ion-thumbnail slot='end' [hidden]="!artShow.metFoto">
                                <ion-img [src]='artShow.imgUrl' (click)="viewerOpen=true"></ion-img>
                            </ion-thumbnail>
                        </td>
                    </tr>
                    <tr>
                        <td><span class="tag">Voorraad</span></td>
                        <td>
                            <div [ngClass]="{'voorraadNeg': artShow.voorraad==0 || artShow.voorraad<0}">{{artShow.voorraadTxt}} {{artShow.eenh}}</div>
                        </td>
                    </tr>
                    <tr *ngIf="artShow.afgeboekt">
                        <td></td>
                        <td><span class="tag">Afgeboekt</span></td>
                        <td>{{artShow.afgeboekt}} {{artShow.eenh}}</td>
                    </tr>
                    <tr *ngIf="artShow.serienr">
                        <td>
                            <ion-button size="small" (click)="doScanSerieNr()" [hidden]="global.optHideScanBtn">
                                <ion-icon name="barcode"></ion-icon>
                            </ion-button>
                        </td>
                        <td><span class="tag">Serie nr.</span></td>
                        <td>
                            <input placeholder="Serie nr." class="inputField" [(ngModel)]="inpSNr"
                                (ngModelChange)="doCheckValid()">
                        </td>
                    </tr>
                    <tr>
                        <td><ion-button size="small" (click)="doType()">+/-</ion-button></td>
                        <td><span class="tag">{{typeBoekingOmsch}}</span></td>
                        <td>
                            <input type='number' placeholder="Aantal" #inpQtyFld style="width: 100px;" class="inputField"
                                [(ngModel)]="inpQty" (ngModelChange)="doCheckValid()" (keyup.enter)="doAfboek()"
                                [disabled]="artShow.serienr"> {{artShow.eenh}}
                        </td>
                    </tr>
                    <tr *ngIf="doShowOmschr">
                        <td></td>
                        <td><span class="tag">Opmerking</span></td>
                        <td colspan="2">
                            <input type='text' placeholder="Opmerking" class="inputField" style="width: 100%;" [(ngModel)]="inpOms">
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>
                            <ion-button (click)="doAfboek()" [disabled]="!validBoeking">
                                Afboeken
                            </ion-button>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </table>
    </mat-card>

    <ion-card>
        <ion-card-title>Afgeboekt</ion-card-title>
        <ion-item>
            <table class="afstand">
                <tr>
                    <td style="padding: 5px;">Qty</td>
                    <td style="padding: 5px;">Art.nr.</td>
                    <td style="padding: 5px;">Omschr</td>
                </tr>
                <tr *ngFor="let row of projShow.verbruik" [ngClass]="{'gereserveerd': row.typ=='R' || row.typ=='W'}"
                    (click)="(row.typ=='R' || row.typ=='W') && dlgRtoB(row.qty, row.art, row.eenh)">
                    <td style="padding: 5px; text-align: right; vertical-align: top;">{{row.qty}}</td>
                    <td style="padding: 5px; vertical-align: top;">
                        {{row.art}}
                        <span *ngIf="(row.typ=='R' || row.typ=='W') && row.loc"><br>→{{row.loc}}</span>
                    </td>
                    <td style="padding: 5px; vertical-align: top;">
                        {{row.des}}<br>
                        <i>{{row.opm}}</i>
                    </td>
                </tr>
            </table>
        </ion-item>
    </ion-card>

</ion-content>
<ion-fab vertical="bottom" horizontal="end" slot="fixed" [hidden]="scanCamera" *ngIf="projValid">
    <ion-fab-button [routerLink]="['/orders']">
        <ion-icon name="clipboard"></ion-icon>
    </ion-fab-button>
</ion-fab>

<app-imageview [open]="viewerOpen" [idx]="0" [imgs]="imgs" [ordnr]="" [currSub]=""
    (close)="viewerOpen = false;"></app-imageview>